import { API_BASE } from '../utils/helpers';

const API_URL = `${API_BASE}/api/categorias`;

async function handle(res) {
  const text = await res.text().catch(() => '');
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {}

  if (!res.ok) {
    if (/<!DOCTYPE html>|<html/i.test(text)) {
      throw new Error('La ruta /api/categorias no esta disponible en el backend actual. Reinicia o despliega el backend actualizado.');
    }
    throw new Error(data?.error || data?.message || text || `Error HTTP ${res.status}`);
  }

  return data;
}

export async function obtenerCategorias() {
  const res = await fetch(API_URL);
  return handle(res);
}

export async function crearCategoria(nombre) {
  const res = await fetch(API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ Nombre: nombre })
  });
  return handle(res);
}

export async function actualizarCategoria(id, nombre) {
  const res = await fetch(`${API_URL}/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ Nombre: nombre })
  });
  return handle(res);
}

export async function eliminarCategoria(id) {
  const res = await fetch(`${API_URL}/${id}`, {
    method: 'DELETE'
  });
  return handle(res);
}
